module.exports = __webpack_public_path__ + "media/10.861a6766.mp3";